import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';

import {
  ArenaFileUpload,
  InputBasic,
  InputDate,
  RadioInput,
  SelectInput,
} from '@/components/input';
import { ButtonContent, ButtonWrapper, InputRows } from '@/pages/inquiry/inquryStyles';
import { InquiryTerms } from '@/pages/inquiry';
import { PrimaryButton } from '@/components/button';
import { Image } from '@/components/shared';
import { BoldText, RegularText } from '@/components/text';
import { color, image } from '@/theme';
import { UploadFileDescription1, UploadFileDescription2 } from '@/lib/react-intl/TranslatedTexts';
import { GoogleRecaptcha } from '@/components/item';
import { LoadingSpinner } from '@/components/loading';

const Warning = styled.div(({ theme }) => ({
  marginTop: '3rem',
  fontWeight: theme.fontWeight.bold,
  fontSize: '1.8rem',
}));

const ArenaRequestDetails = ({
  control,
  setStep,
  setValue,
  errors,
  fileList,
  setFileList,
  stageType,
  retractableOptions,
  isPending,
}) => {
  const [termsAgree, setTermsAgree] = useState(false);

  const goToPrev = useCallback(() => {
    setStep(1);
  }, [setStep]);

  useEffect(() => {
    setValue('term', termsAgree);
  }, [termsAgree, setValue]);

  return (
    <>
      <InputBasic
        control={control}
        name="event_name"
        label="lang-event-name"
        placeholder="lang-placeholder-event"
        maxLength={50}
        required
      />

      <InputBasic
        type="number"
        control={control}
        name="attendees"
        label="lang-attendees-arena"
        placeholder="lang-placeholder-attendees-arena"
        maxLength={50}
        required
      />

      <InputRows>
        <InputDate
          control={control}
          name="event_start_date"
          label="lang-event-start-date"
          errors={errors}
          required
        />

        <InputDate
          control={control}
          name="event_end_date"
          label="lang-event-end-date"
          errors={errors}
          required
        />
      </InputRows>

      <InputRows>
        <InputDate
          control={control}
          name="preparation_start_date"
          label="lang-preparation-start-date"
          errors={errors}
        />

        <InputDate
          control={control}
          name="preparation_end_date"
          label="lang-preparation-end-date"
          errors={errors}
        />
      </InputRows>

      <InputRows>
        <InputDate
          control={control}
          name="dismantle_start_date"
          label="lang-dismantle-start-date"
          errors={errors}
        />

        <InputDate
          control={control}
          name="dismantle_end_date"
          label="lang-dismantle-end-date"
          errors={errors}
        />
      </InputRows>

      <SelectInput
        control={control}
        errors={errors}
        name="stage_type"
        arr={stageType}
        label="lang-stage-type"
        required
      />

      <RadioInput
        control={control}
        name="retractable_chair_yn"
        label="lang-use-of-retractable-chairs"
        arr={retractableOptions}
        required
      />

      <InputBasic
        control={control}
        name="comments"
        label="lang-requirements"
        multiline
        rows={10}
        placeholder="lang-placeholder-requirements"
        maxLength={500}
      />

      <ArenaFileUpload
        fileList={fileList}
        setFileList={setFileList}
        description1={<UploadFileDescription1 />}
        description2={<UploadFileDescription2 />}
        errors={errors}
      />

      <Warning>
        <BoldText id="lang-complete-form-warning" fontSize="1.8rem" />
      </Warning>

      <InquiryTerms
        checked={termsAgree}
        setChecked={setTermsAgree}
        errors={errors}
        setValue={setValue}
      />

      <GoogleRecaptcha setValue={setValue} errors={errors} />

      <ButtonWrapper>
        {isPending ? (
          <LoadingSpinner />
        ) : (
          <>
            <PrimaryButton type="button" onClick={goToPrev}>
              <ButtonContent>
                <Image src={image.arrowLeft.default} width="1.8rem" height="1.4rem" />

                <RegularText id="lang-prev" color={color.base_white} />
              </ButtonContent>
            </PrimaryButton>

            <PrimaryButton type="submit" width="92%">
              <ButtonContent>
                <RegularText id="lang-inquiry-submit" color={color.base_white} />

                <Image src={image.arrowRight.default} width="1.8rem" height="1.4rem" />
              </ButtonContent>
            </PrimaryButton>
          </>
        )}
      </ButtonWrapper>
    </>
  );
};

export default ArenaRequestDetails;
